<div #froalaContentContainer>
  <div class="fr-view fr-long-image" [innerHtml]="editorContent | getHtmlContentForFroalaContentWrapper" #froalaContent></div>
</div>
